import * as api from "services/api";
import { getErrors } from "helpers/error";

export const GET_BANK_BILLETS = "[BANK_BILLET REPORT] GET_BANK_BILLETS";
export const GET_BANK_BILLETS_SUCCESS =
	"[BANK_BILLET REPORT] GET_BANK_BILLETS_SUCCESS";
export const GET_BANK_BILLETS_FAILED = "[BANK_BILLET REPORT] GET_BANK_BILLETS_FAILED";

export const IMPORT_BANK_BILLETS = "[BANK_BILLET REPORT] IMPORT_BANK_BILLETS";
export const IMPORT_BANK_BILLETS_SUCCESS =
	"[BANK_BILLET REPORT] IMPORT_BANK_BILLETS_SUCCESS";
export const IMPORT_BANK_BILLETS_FAILED =
	"[BANK_BILLET REPORT] IMPORT_BANK_BILLETS_FAILED";

export const SET_VALUE = "[BANK_BILLET REPORT] SET_VALUE";

export function setValue(payload) {
	return { type: SET_VALUE, payload };
}

export function importBankBillets(
	data,
	callback
) {
	return async (dispatch, getState) => {
		dispatch({ type: IMPORT_BANK_BILLETS });

		try {
			const { login } = getState();

			var response = await api.sendPost(`/BankBillet/Import`, data, {
				Authorization: "Bearer " + login.token,
			});

			let result = await response.json();

			if (result.isValid) {
				dispatch({
					type: IMPORT_BANK_BILLETS_SUCCESS,
					payload: result.model,
				});

				callback && callback(null, result.model);
			} else {
				const errors = getErrors(result.errors);

				dispatch({
					type: IMPORT_BANK_BILLETS_FAILED,
					payload: errors,
				});
				callback && callback(errors);
			}
		} catch (error) {
			return dispatch({
				type: IMPORT_BANK_BILLETS_FAILED,
				payload: {
					error: "Connection error",
				},
			});
		}
	};
}

export function getBankBillets(
	skip,
	take,
	filter,
	sort,
	desc,
	toExport,
	callback
) {
	return async (dispatch, getState) => {
		dispatch({ type: GET_BANK_BILLETS });

		try {
			const { login } = getState();

			var response = await api.sendGet(
				`/BankBillet?skip=${skip}&take=${take}&sort=${sort}&desc=${desc}${
					filter || "&filters=null"
				}`,
				{
					Authorization: "Bearer " + login.token,
				}
			);

			let result = await response.json();

			if (result.isValid) {
				if (toExport) {
					dispatch(setValue({ loading: false }));
				} else {
					dispatch({
						type: GET_BANK_BILLETS_SUCCESS,
						payload: result.model,
					});

					if (result.params)
						dispatch(
							setValue({
								pages: Math.ceil(result.params.count / take),
								...result.params,
							})
						);
				}

				callback && callback(null, result.model);
			} else {
				const errors = getErrors(result.errors);

				dispatch({
					type: GET_BANK_BILLETS_FAILED,
					payload: errors,
				});
				callback && callback(errors);
			}
		} catch (error) {
			return dispatch({
				type: GET_BANK_BILLETS_FAILED,
				payload: {
					error: "Connection error",
				},
			});
		}
	};
}
